import type { ApolloError } from '@apollo/client';

const ZIP_CODE_ERROR_MESSAGE = 'Invalid zipcode provided';

export function isInvalidZipCodeError(error: ApolloError | undefined) {
  if (!error || !error.graphQLErrors || error.graphQLErrors.length !== 1) {
    return false;
  }
  return error.graphQLErrors[0].message === ZIP_CODE_ERROR_MESSAGE;
}
